import gql from 'graphql-tag';

export const getAllOffersByAdmin = gql`
 query getAllOffersByAdmin{
  getAllOffersByAdmin{
      id
      title
      offerPrice
      saleOff
      quantities
      status
      active
      offerStartDetail
      offerEndDetail
      category {
        id
        name
      }
      merchant {
        id
        username
      }
    }
  }
`;
